var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _ellipse2, _g, _rect, _rect2, _rect3, _rect4, _rect5, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel5Badge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 304,
    viewBox: "0 0 790 523",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M376.539 39.2695H417.467L402.072 269.065H387.053L376.539 39.2695Z",
    fill: "url(#paint0_linear_6927_3289)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M376.539 484.596H417.467L402.072 254.8H387.053L376.539 484.596Z",
    fill: "url(#paint1_linear_6927_3289)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M685.002 241.477L685.002 282.404L389.87 267.009L389.87 251.99L685.002 241.477Z",
    fill: "url(#paint2_linear_6927_3289)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.001 241.477L106.001 282.404L404.137 267.009L404.137 251.99L106.001 241.477Z",
    fill: "url(#paint3_linear_6927_3289)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M557.974 502.412L522.529 522.876L388.295 259.589L401.302 252.079L557.974 502.412Z",
    fill: "url(#paint4_linear_6927_3289)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M252.124 0.992189L216.679 21.456L379.079 271.95L392.087 264.44L252.124 0.992189Z",
    fill: "url(#paint5_linear_6927_3289)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M656.448 388.959L635.984 424.403L388.09 263.506L395.599 250.499L656.448 388.959Z",
    fill: "url(#paint6_linear_6927_3289)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.668 99.4746L118.204 134.919L384.095 270.654L391.605 257.647L138.668 99.4746Z",
    fill: "url(#paint7_linear_6927_3289)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M268.473 522.879L233.028 502.415L393.927 254.522L406.934 262.032L268.473 522.879Z",
    fill: "url(#paint8_linear_6927_3289)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M573.443 21.4531L537.998 0.989276L402.262 266.878L415.27 274.388L573.443 21.4531Z",
    fill: "url(#paint9_linear_6927_3289)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M155.019 424.402L134.555 388.958L397.844 254.725L405.354 267.732L155.019 424.402Z",
    fill: "url(#paint10_linear_6927_3289)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M671.916 134.92L651.452 99.4755L400.956 261.875L408.466 274.882L671.916 134.92Z",
    fill: "url(#paint11_linear_6927_3289)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 395,
    cy: 394.5,
    rx: 395,
    ry: 48.5,
    fill: "url(#paint12_radial_6927_3289)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 424.532,
    cy: 394.501,
    rx: 254.126,
    ry: 9.7,
    fill: "url(#paint13_radial_6927_3289)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_6927_3289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 139.117,
    width: 173.783,
    height: 173.783,
    rx: 12.8003,
    transform: "rotate(45 395 139.117)",
    fill: "url(#paint14_linear_6927_3289)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 307.958,
    y: 174.959,
    width: 174.085,
    height: 174.085,
    rx: 12.8003,
    fill: "url(#paint15_linear_6927_3289)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_6927_3289)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 336.118,
    y: 203.117,
    width: 117.763,
    height: 117.763,
    rx: 6.40017,
    fill: "url(#paint16_radial_6927_3289)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 336.118,
    y: 203.117,
    width: 117.763,
    height: 117.763,
    rx: 6.40017,
    fill: "url(#paint17_radial_6927_3289)",
    fillOpacity: 0.29
  })), /*#__PURE__*/React.createElement("rect", {
    x: 336.118,
    y: 203.117,
    width: 117.763,
    height: 117.763,
    rx: 6.40017,
    fill: "url(#paint18_linear_6927_3289)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 330.998,
    y: 197.997,
    width: 128.003,
    height: 128.003,
    rx: 11.5203,
    stroke: "url(#paint19_linear_6927_3289)",
    strokeWidth: 10.2403
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.47,
    x: 325.031,
    y: 192.031,
    width: 139.938,
    height: 139.938,
    rx: 17.9567,
    stroke: "url(#paint20_linear_6927_3289)",
    strokeWidth: 1.23839
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_6927_3289)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6927_3289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.051 276.595C369.484 279.077 372.701 280.389 377.353 280.389C379.444 280.389 381.748 280.095 384.147 279.59C386.458 286.669 390.146 291.195 394.391 291.195C398.636 291.195 402.324 286.669 404.635 279.59C407.037 280.093 409.338 280.389 411.429 280.389C416.079 280.389 419.297 279.077 420.73 276.595C422.584 273.381 420.943 267.981 415.317 261.995C420.943 256.009 422.584 250.609 420.73 247.395C419.297 244.913 416.079 243.601 411.428 243.601C409.336 243.601 407.033 243.895 404.633 244.4C402.324 237.321 398.636 232.795 394.391 232.795C390.146 232.795 386.458 237.321 384.147 244.4C381.746 243.895 379.443 243.601 377.353 243.601C372.701 243.601 369.484 244.913 368.051 247.395C366.197 250.609 367.837 256.009 373.464 261.995C367.837 267.981 366.195 273.381 368.051 276.595ZM394.391 289.37C391.035 289.37 387.974 285.357 385.947 279.188C388.835 278.444 391.659 277.468 394.391 276.27C397.123 277.468 399.947 278.444 402.835 279.188C400.808 285.357 397.747 289.37 394.391 289.37ZM383.441 261.995C383.441 259.871 383.554 257.803 383.748 255.803C385.424 254.634 387.148 253.536 388.916 252.512C390.694 251.49 392.521 250.556 394.391 249.714C396.233 250.545 398.07 251.474 399.866 252.512C401.635 253.535 403.359 254.633 405.035 255.803C405.228 257.803 405.341 259.871 405.341 261.995C405.341 264.119 405.228 266.187 405.035 268.187C403.359 269.356 401.634 270.454 399.866 271.478C398.088 272.5 396.261 273.434 394.391 274.275C392.52 273.435 390.693 272.501 388.916 271.478C387.147 270.455 385.423 269.357 383.748 268.187C383.546 266.129 383.444 264.063 383.441 261.995ZM381.795 266.782C379.818 265.307 377.937 263.708 376.163 261.995C377.937 260.282 379.818 258.683 381.795 257.208C381.687 258.766 381.616 260.356 381.616 261.995C381.616 263.634 381.687 265.223 381.795 266.782ZM384.027 253.392C384.336 251.079 384.802 248.79 385.421 246.541C387.709 247.13 389.954 247.874 392.141 248.765C390.75 249.439 389.363 250.147 388.004 250.932C386.656 251.716 385.33 252.536 384.027 253.392ZM396.64 248.765C398.827 247.874 401.072 247.13 403.359 246.541C403.947 248.64 404.418 250.945 404.754 253.392C403.451 252.535 402.125 251.715 400.777 250.932C399.425 250.159 398.045 249.437 396.64 248.765ZM406.987 257.208C408.965 258.682 410.846 260.281 412.619 261.995C410.845 263.708 408.964 265.307 406.987 266.782C407.095 265.223 407.166 263.634 407.166 261.995C407.166 260.356 407.095 258.766 406.987 257.208ZM404.755 270.598C404.446 272.911 403.98 275.2 403.361 277.449C401.074 276.86 398.829 276.116 396.641 275.224C398.047 274.554 399.428 273.831 400.781 273.058C402.127 272.274 403.453 271.454 404.755 270.598ZM388.004 273.058C389.363 273.843 390.75 274.553 392.143 275.224C389.956 276.116 387.711 276.86 385.423 277.449C384.804 275.2 384.338 272.911 384.029 270.598C385.288 271.421 386.593 272.242 388.004 273.058ZM419.151 275.682C418.078 277.542 415.337 278.564 411.431 278.564C409.504 278.564 407.383 278.298 405.168 277.843C405.933 275.027 406.468 272.154 406.768 269.251C409.59 267.273 411.971 265.295 413.959 263.358C418.58 268.253 420.759 272.896 419.151 275.682ZM411.429 245.426C415.335 245.426 418.078 246.45 419.149 248.307C420.759 251.094 418.578 255.737 413.957 260.632C411.97 258.697 409.588 256.717 406.767 254.739C406.466 251.836 405.931 248.963 405.166 246.147C407.382 245.692 409.504 245.426 411.429 245.426ZM394.391 234.62C397.747 234.62 400.808 238.633 402.835 244.802C400.092 245.497 397.24 246.481 394.391 247.72C391.659 246.522 388.835 245.546 385.947 244.802C387.974 238.633 391.035 234.62 394.391 234.62ZM369.631 248.307C370.705 246.448 373.446 245.426 377.351 245.426C379.278 245.426 381.399 245.692 383.615 246.147C382.849 248.963 382.314 251.836 382.014 254.739C379.193 256.717 376.811 258.695 374.824 260.632C370.203 255.737 368.024 251.094 369.631 248.307ZM374.824 263.358C376.811 265.293 379.193 267.273 382.014 269.251C382.35 272.354 382.892 275.244 383.615 277.843C381.401 278.298 379.28 278.564 377.353 278.564C373.447 278.564 370.703 277.54 369.631 275.682C368.024 272.896 370.203 268.253 374.824 263.358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.391 266.557C396.905 266.557 398.953 264.511 398.953 261.994C398.953 259.477 396.905 257.432 394.391 257.432C391.876 257.432 389.828 259.477 389.828 261.994C389.828 264.511 391.876 266.557 394.391 266.557ZM394.391 259.257C395.9 259.257 397.128 260.485 397.128 261.994C397.128 263.503 395.9 264.732 394.391 264.732C392.881 264.732 391.653 263.503 391.653 261.994C391.653 260.485 392.881 259.257 394.391 259.257Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_6927_3289",
    x: 277.418,
    y: 135.46,
    width: 235.163,
    height: 249.242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.12014
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.04019
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.645833 0 0 0 0 1 0 0 0 0 0.645833 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6927_3289"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -8.96024
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.12014
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0196078 0 0 0 0 0.505882 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_6927_3289",
    result: "effect2_innerShadow_6927_3289"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_6927_3289",
    x: 325.878,
    y: 192.877,
    width: 138.244,
    height: 138.244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.8008
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.407843 0 0 0 0 0.0117647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6927_3289"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_6927_3289",
    x: 367.017,
    y: 232.799,
    width: 54.75,
    height: 63.6147,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.21429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.25833
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6927_3289"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6927_3289",
    x1: 397.003,
    y1: 39.2695,
    x2: 397.003,
    y2: 269.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6927_3289",
    x1: 397.003,
    y1: 484.596,
    x2: 397.003,
    y2: 254.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6927_3289",
    x1: 657.591,
    y1: 261.94,
    x2: 389.87,
    y2: 261.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6927_3289",
    x1: 110.131,
    y1: 261.94,
    x2: 404.137,
    y2: 261.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6927_3289",
    x1: 526.546,
    y1: 488.906,
    x2: 392.687,
    y2: 257.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6927_3289",
    x1: 236.466,
    y1: 14.8011,
    x2: 383.467,
    y2: 269.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6927_3289",
    x1: 622.478,
    y1: 392.976,
    x2: 390.625,
    y2: 259.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6927_3289",
    x1: 132.013,
    y1: 119.262,
    x2: 386.629,
    y2: 266.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6927_3289",
    x1: 264.456,
    y1: 488.909,
    x2: 398.315,
    y2: 257.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6927_3289",
    x1: 553.655,
    y1: 14.7982,
    x2: 406.654,
    y2: 269.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6927_3289",
    x1: 168.525,
    y1: 392.975,
    x2: 400.378,
    y2: 259.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6927_3289",
    x1: 658.107,
    y1: 119.263,
    x2: 403.492,
    y2: 266.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_6927_3289",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(395 394.5) rotate(90) scale(48.5 395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#013E00",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#058404",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_6927_3289",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(424.532 394.501) rotate(90) scale(9.7 254.126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#013E00",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#058404",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6927_3289",
    x1: 381.876,
    y1: 194.782,
    x2: 543.814,
    y2: 314.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61DF61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#168416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6927_3289",
    x1: 341.203,
    y1: 186.875,
    x2: 401.523,
    y2: 347.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79F07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F921F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_6927_3289",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(395 264.604) rotate(90) scale(95.7778 96.9111)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FDB0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#089604"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_6927_3289",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(367.482 242.138) rotate(-43.9093) scale(63.937 33.9229)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6927_3289",
    x1: 395,
    y1: 203.117,
    x2: 395,
    y2: 326.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005900",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6927_3289",
    x1: 395,
    y1: 203.117,
    x2: 395,
    y2: 326.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#209220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AF17A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6927_3289",
    x1: 362.758,
    y1: 184.742,
    x2: 419.333,
    y2: 342.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFFFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46C146"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6927_3289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.75,
    height: 58.4,
    fill: "white",
    transform: "translate(367.017 232.799)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel5Badge);
export default __webpack_public_path__ + "static/media/Level5Badge.973a172873141b5493cf2dd23e6abd79.svg";
export { ForwardRef as ReactComponent };